<p-card>
  <ng-template pTemplate="header">
    <p>Sezione di Playground</p>
  </ng-template>
  <ng-template pTemplate="body">
    <ul>
      <li>{{contractStrigifier.loginMaster}}</li>
      <li>{{contractStrigifier.servizioNavigation.id}}</li>
    </ul>

    <!--        <button (click)="getAb()">Get AB (guarda la console)</button>-->

    <label appCopyable>Ciao, sono Daniele</label>
    <p appCopyable>Paragrafo</p>
    <button appCopyable (click)="showAlert()">Pulsante</button>

    <p-button (click)="loadTypedTest()">Prova Typed test</p-button>
    @if (typedTest != null) {
      <div>
        {{typedTest.name}} at {{typedTest.timestamp}}
        @for (message of typedTest.messages; track message) {
          <div>
            TEXT: {{message.text}}<br>
            Date: {{message.timestamp}}
          </div>
        }
      </div>
    }


    <p-button (click)="loadTypedTestList()">Prova Typed test LIST</p-button>
    @if (typedTestList!= null) {
      <div>
        @for (item of typedTestList.dataList; track item) {
          <div>
            {{item.name}} at {{item.timestamp}}
            @for (message of item.messages; track message) {
              <div>
                TEXT: {{message.text}}<br>
                Date: {{message.timestamp}}
              </div>
            }
          </div>
        }
      </div>
    }

    <p-button (click)="testSignalRSendMessage()">Prova Send SignalR message</p-button>

  </ng-template>
</p-card>

<p-card>
  <ng-template pTemplate="header">
    <h3>Apertura ticket massiva</h3>
  </ng-template>
  <ng-template pTemplate="body">
    <app-massive-ticket-sender></app-massive-ticket-sender>
  </ng-template>
</p-card>
